import { render, staticRenderFns } from "./AppProduto.vue?vue&type=template&id=4b4ceba4&"
import script from "./AppProduto.vue?vue&type=script&lang=js&"
export * from "./AppProduto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports